import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { routerRegister } from "@utils/router";
import { RouterProvider } from "react-router-dom";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

export const Application = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={routerRegister} />
    </QueryClientProvider>
  );
};
